import {
  CategoryScale,
  Chart as ChartJS,
  Filler,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from "chart.js";
import { Line } from "react-chartjs-2";
import ChartSkeleton from "./Skeleton/ChartSkeleton";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler // Filler is essential for Area charts
);

const RevenueChart = ({ data, options, loading }) => {
  const revenueChartData = {
    labels: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ],
    datasets: [
      {
        label: "Revenue",
        data: [
          400000, 410000, 420000, 430000, 440000, 450000, 460000, 470000,
          480000, 490000, 500000, 510000,
        ],
        // data: [],
        fill: "start", // Fills the area from the line to the x-axis
        backgroundColor: "rgba(129, 140, 248, 0.7)", // Light purple/blue fill color
        borderColor: "rgba(129, 140, 248, 1)", // Line color
        tension: 0.1, // Straight line
        pointRadius: 0, // Hides the points on the line
        borderWidth: 3,
      },
    ],
  };

  const revenueChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
        position: "top",
        align: "end",
      },
      subtitle: {
        display: true,
        text: "Custom Chart Subtitle",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
    },
    animations: {
      tension: {
        duration: 1000,
        easing: "linear",
        from: 1,
        to: 0,
        loop: true,
      },
    },
    scales: {
      x: {
        grid: {
          display: true, // Hides vertical grid lines
        },
        ticks: {
          color: "#555",
        },
        border: {
          display: false,
        },
      },
      y: {
        min: 0,
        max: 600000,
        ticks: {
          // Formats the y-axis labels to include commas and a trailing zero if needed, similar to the image
          callback: function (value) {
            if (value === 0) return "0";
            return value.toLocaleString(); // Add commas
          },
          stepSize: 150000,
          color: "#555",
        },
        grid: {
          color: "rgba(0, 0, 0, 0.1)", // Light horizontal grid lines
        },
        border: {
          display: false,
        },
      },
    },
    // Custom element styling to match the flat area look
    elements: {
      line: {
        borderCapStyle: "round",
      },
    },
  };
  return (
    <div style={{ height: "400px", width: "100%" }}>
      {loading ? (
        <ChartSkeleton />
      ) : (
        <Line
          data={revenueChartData}
          options={revenueChartOptions}
          style={{ width: "100%", height: "100%" }}
        />
      )}
    </div>
  );
};

export default RevenueChart;
